import React from "react";
import GriReport from "../GriReport";

export default function GriReportPage({ sessionObject }) {
  if (!sessionObject.sessionVariables["modules"].includes("gri-report")) {
    return;
  }
  return (
    <div className="page-challan">
      <GriReport sessionObject={sessionObject} />
    </div>
  );
}
